if (typeof window.SectionTemoignages === 'undefined') {
  class SectionTemoignages {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
      this.prevBtn = document.querySelector('.js-temoignages-prev');
      this.nextBtn = document.querySelector('.js-temoignages-next');
      this.splideInstance = undefined;
      this.init();
    }

    init() {
      if (!this.splideContainer || typeof window.Splide === 'undefined') return;
      this.splideInstance = new window.Splide(this.splideContainer, {
        type: 'slide',
        perPage: 1,
        arrows: false,
        pagination: false,
        autoHeight: true,
        gap: '1rem',
        rewind: true,
        duration: 1500,
        dragMinThreshold: 5,
        flickPower: 100,
        autoplay: true,
        interval: 5000,
        mediaQuery: 'min',
        speed: 500,
        easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        breakpoints: {
          1024: {
            perPage: 4,
            gap: '7rem',
          },
        },
      });
      this.splideInstance.on('mounted move', () => this.updateNavState());
      this.splideInstance.mount();
      this.bindCustomNav();
      this.updateNavState();
    }

    bindCustomNav() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.splideInstance.go('<');
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.splideInstance.go('>');
        });
      }
    }

    updateNavState() {
      if (!this.splideInstance) return;
      const idx = this.splideInstance.index;
      const lastIdx = this.splideInstance.length - 1;
      if (this.prevBtn) {
        this.prevBtn.disabled = idx === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = idx === lastIdx;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-temoignages-slider').forEach(function(splide) {
      new SectionTemoignages(splide);
    });
  });
}


